module.exports = __webpack_public_path__ + "img/idea-vision-honest-icon.22e6d561.svg";